import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { SidePageWrapper } from "../../../layout/sidePageWrapper/SidePageWrapper";

export const Registration = () => {
  const { t } = useTranslation(["app"]);

  return (
    <SidePageWrapper
      hideDisclaime={true}
      bannerHeading={t("app:login_page_heading")}
      bannerParas={[
        t(
          "app:login_page_para_1"
        ),
        t(
          "app:login_page_para_2"
        ),
      ]}
    >
      <Outlet />
    </SidePageWrapper>
  );
};
